module.exports = __webpack_public_path__ + "img/curso_7_texto.8d4e694d.png";